module.exports = __webpack_public_path__ + "img/reportAvatar3.5c5dbcd3.png";